/** 해외사역지 지역(대륙) 구분 — 공고 등록 지역 선택 · 목록 지역 필터 */
export const OVERSEAS_REGIONS = ['아시아', '북미', '중남미', '유럽', '오세아니아', '아프리카', '중동'];

/** 목록에 없는 국가를 직접 입력할 때 선택하는 값 */
export const OVERSEAS_COUNTRY_ETC = '기타(직접입력)';

/** 대륙별 국가 목록 (한인교회·선교지 위주) */
export const OVERSEAS_COUNTRIES: Record<string, string[]> = {
  아시아: [
    '일본', '중국', '대만', '홍콩', '몽골', '필리핀', '베트남', '태국', '캄보디아', '라오스', '미얀마',
    '말레이시아', '싱가포르', '인도네시아', '인도', '네팔', '방글라데시', '스리랑카', '카자흐스탄',
    '우즈베키스탄', '키르기스스탄',
  ],
  북미: ['미국', '캐나다'],
  중남미: ['멕시코', '과테말라', '브라질', '아르헨티나', '파라과이', '칠레', '페루', '볼리비아', '콜롬비아', '에콰도르', '도미니카공화국'],
  유럽: [
    '영국', '독일', '프랑스', '네덜란드', '벨기에', '스위스', '오스트리아', '이탈리아', '스페인', '포르투갈',
    '체코', '폴란드', '헝가리', '스웨덴', '노르웨이', '핀란드', '덴마크', '아일랜드', '러시아', '우크라이나', '튀르키예',
  ],
  오세아니아: ['호주', '뉴질랜드', '피지', '파푸아뉴기니'],
  아프리카: ['남아프리카공화국', '케냐', '탄자니아', '우간다', '에티오피아', '나이지리아', '가나', '르완다', '말라위', '이집트'],
  중동: ['아랍에미리트', '카타르', '사우디아라비아', '쿠웨이트', '바레인', '오만', '요르단', '이스라엘', '레바논'],
};

/** 해외 공고 위치·주소 입력값 — recruitMinisterOverseas의 country/city/state/postalCode/addressLine1/addressLine2 컬럼 */
export type OverseasLocationValue = {
  region: string;
  country: string;
  city: string;
  state: string;
  postalCode: string;
  addressLine1: string;
  addressLine2: string;
};

export const EMPTY_OVERSEAS_LOCATION: OverseasLocationValue = {
  region: '',
  country: '',
  city: '',
  state: '',
  postalCode: '',
  addressLine1: '',
  addressLine2: '',
};

/** 구글 지도 검색·표시용 전체 주소 (해외 주소 표기 순서: 상세주소, 도시, 주, 우편번호, 국가) */
export function composeOverseasAddress(v: OverseasLocationValue): string {
  return [v.addressLine1, v.addressLine2, v.city, v.state, v.postalCode, v.country]
    .map((part) => part.trim())
    .filter(Boolean)
    .join(', ');
}

/** 저장할 값 — 기존 location/locationDetail/address 컬럼(목록·검색·상세용)과 해외 전용 컬럼을 함께 채운다 */
export function toOverseasLocationParams(v: OverseasLocationValue) {
  return {
    location: v.region,
    locationDetail: [v.country, v.city].map((part) => part.trim()).filter(Boolean).join(' '),
    address: composeOverseasAddress(v),
    country: v.country.trim(),
    city: v.city.trim(),
    state: v.state.trim(),
    postalCode: v.postalCode.trim(),
    addressLine1: v.addressLine1.trim(),
    addressLine2: v.addressLine2.trim(),
  };
}

/** DB 행 → 입력값. 해외 전용 컬럼이 비어 있는 예전 글은 기존 주소를 주소 1에 넣어 보여준다 */
export function parseOverseasLocation(row: Record<string, unknown>): OverseasLocationValue {
  const str = (key: string) => String(row[key] ?? '');
  const hasStructured = Boolean(str('country') || str('addressLine1'));
  if (hasStructured) {
    return {
      region: str('location'),
      country: str('country'),
      city: str('city'),
      state: str('state'),
      postalCode: str('postalCode'),
      addressLine1: str('addressLine1'),
      addressLine2: str('addressLine2'),
    };
  }
  return {
    ...EMPTY_OVERSEAS_LOCATION,
    region: str('location'),
    city: str('locationDetail'),
    addressLine1: str('address'),
  };
}
